import React from "react";
import PropTypes from "prop-types";

import HeaderView from "features/application/header/view";
import Authentication from "features/application/authentication/component";
import Form from "features/application/form/component";
import Loader from "features/application/loader/component";

import "screens/application/component/view.scss";

const ApplicationView = ({
  responseCodes,
  errorCodes,
  errorFields,
  currentStep,
  urlUserId,
  urlEmailId,
  urlParameters,
  history,
  userData,
  memberships,
  signOut,
}) => (
  <main className="application">
    <HeaderView userData={userData} signOut={signOut} />
    {userData ? (
      <Form
        responseCodes={responseCodes}
        errorCodes={errorCodes}
        errorFields={errorFields}
        currentStep={currentStep}
        userData={userData}
        memberships={memberships}
      />
    ) : (
      <Authentication
        responseCodes={responseCodes}
        errorCodes={errorCodes}
        currentStep={currentStep}
        urlUserId={urlUserId}
        urlEmailId={urlEmailId}
        urlParameters={urlParameters}
        history={history}
      />
    )}
    <Loader />
  </main>
);

ApplicationView.propTypes = {
  responseCodes: PropTypes.object,
  errorCodes: PropTypes.object,
  errorFields: PropTypes.object,
  currentStep: PropTypes.string,
  urlUserId: PropTypes.string,
  urlParameters: PropTypes.string,
  history: PropTypes.object,
  userData: PropTypes.object,
  memberships: PropTypes.array,
  signOut: PropTypes.func,
  urlEmailId: PropTypes.string,
};

export default ApplicationView;
